import { trimStart } from "lodash";
import React from "react";
import { Button, Input, Modal, Notification, toaster } from "rsuite";
import { ResponseDefault } from "../../../../core/interfaces/interfaces";
import { MethodsUtils } from "../../../../core/utils/MethodsUtils";
import axios from "../../../../utilities/axios";
import "./styles/sytleResetPassword.css";
import iziToast from "izitoast";

type ResetPass = {
  userId: number;
  userCpf: string;
  justification: string;
  solicitedBy: string;
};

type State = {
  viewModalJustification: boolean;
  justification: string;
  dataInfo: any;
  data: any;
  isResetting: boolean;
};

export default class ResetPasswordUser extends React.Component<any, State> {
  state: State = {
    viewModalJustification: false,
    justification: "",
    dataInfo: null,
    data: this.props.values,
    isResetting: false,
  };

  async componentDidMount(): Promise<void> {
    try {
      const response = await axios.get("/api/v1/me");
      const dataInfo = response.data.user;
      this.setState({ dataInfo });
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
    }
  }

  handleClickReset = () => {
    this.setState({ viewModalJustification: true });
  };

  closeModalReset = () => {
    this.setState({
      justification: "",
      viewModalJustification: false,
      isResetting: false,
    });
  };

  resetPassword = async (
    loggedID: number,
    loggedName: string,
    loggedRole: string,
    loggedRoleId: number
  ) => {
    this.setState({ isResetting: true });
    try {
      const data = this.props.values;
      const restorePass: ResetPass = {
        userId: data.user_id,
        userCpf: data.user_cpf_cnpj,
        justification: this.state.justification,
        solicitedBy: `ID: ${loggedID} - Nome: ${loggedName} - Tipo de Regra: ${loggedRole} - RoleID: ${loggedRoleId}`,
      };

      const sendReq: ResponseDefault = await axios
        .post("/api/v1/user/reset", { restorePass })
        .then((res) => {
          return res.data;
        });

      if (sendReq.status === 200) {
        this.closeModalReset();
        iziToast.success({
          title: "Sucesso",
          message: sendReq.message,
          position: "topRight",
          timeout: 5000,
          close: true,
        });
      } else {
        iziToast.error({
          title: "Sucesso",
          message: sendReq.message,
          position: "topRight",
          timeout: 5000,
          close: true,
        });
      }

    } catch (e) {
      console.error("Erro ao redefinir senha:", e);
      iziToast.error({
        title: "Erro",
        message: "Ocorreu um erro ao redefinir a senha.",
        position: "topRight",
        timeout: 5000,
        close: true,
      });

    } finally {
      this.setState({ isResetting: false });
    }
  };

  render() {
    const { viewModalJustification, justification, dataInfo, data } =
      this.state;
    return (
      <>
        <div className="containner-button">
          <Button
            appearance="primary"
            color="violet"
            onClick={this.handleClickReset}
          >
            Redefinir Senha
          </Button>
        </div>

        <Modal
          className="containner-modal"
          open={this.state.viewModalJustification}
          size="lg"
          onClose={this.closeModalReset}
          backdrop="static"
          onExit={this.closeModalReset}
          keyboard={true}
        >
          <Modal.Header>
            <Modal.Title>REDEFINIR SENHA</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <strong>CPF:</strong>{" "}
            {MethodsUtils.FormatCpfCnpj(data.user_cpf_cnpj)} -{" "}
            <strong>Nome:</strong> {data.user_name}
            <p>
              <div className="margin-10">
                <span>
                  <strong>JUSTIFIQUE O MOTIVO PARA A REDEFINIÇÃO</strong>
                </span>
              </div>
            </p>
            <div className="margin-10">
              <Input
                id="justification"
                className="justification"
                as="textarea"
                rows={3}
                placeholder="Justificativa obrigatória"
                value={this.state.justification}
                onChange={(e) => {
                  const value = e.slice(0, 200);
                  this.setState({ justification: trimStart(value) });
                }}
              />
              <span className="counter">
                {this.state.justification.length}/200
              </span>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button color="red" onClick={this.closeModalReset}>
              Fechar
            </Button>

            <Button
              color="cyan"
              disabled={
                this.state.justification.length <= 10 || this.state.isResetting
              }
              onClick={() =>
                this.resetPassword(
                  dataInfo.user_id,
                  dataInfo.user_name,
                  dataInfo.role.role_name,
                  dataInfo.role.role_id
                )
              }
            >
              {" "}
              {this.state.isResetting ? (
                <>
                  <span
                    className="rs-icon rs-icon-spinner rs-icon-spin"
                    style={{ marginRight: 8 }}
                  />
                  Processando...
                </>
              ) : (
                "Redefinir"
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
